
export const Logo = ({ className }: { className?: string }) => {
    return (
        <img
            src="https://cdn.dashbal.com/logos/dashbal/logo_main.svg"
            className={className}
            alt="Dashbal"
        />
    );
};
